import { IconCollection } from "components/Icon/IconCollection";
import { RelationshipConfig } from "config/config";
import {
    deleteActionSignature,
    DeleteListAction,
} from "containers/Resources/components/CommonActions/CommonActions";

const defaultValueEnums = { icon: null, label: "ALL", value: null };
const defaultValueProjects = { icon: null, label: "All projects", value: null };
const defaultValueObjectTemplates = { icon: null, label: "All object templates", value: null };

const rolePermissionVariables = `
    $project_id: String,
    $table_type: RecordType,
    $operation: PermissionOperation,
    $object_template_id: String,
`;
const rolePermissionQuery = `
    project_id: $project_id,
    table_type: $table_type,
    operation: $operation,
    object_template_id: $object_template_id,
`;

const config: RelationshipConfig = {
    label: "Role permission",
    icon: IconCollection.cubeSend,
    resourceName: "role_permission",
    resourceClass: "relationship",
    parentResourceName: "role",
    parentReferenceField: "role_id",
    parentReferenceName: "role_id_role.name",
    layout: [],
    hideCreateNew: true,
    actions: {
        shown: [],
        hidden: [deleteActionSignature],
    },
    listActions: {
        shown: [],
        hidden: [{ key: "delete", action: DeleteListAction }],
    },
    graphql: {
        resource: "role_permission",
        resourceBody: `
            id
            role_id
            role_id_role{
                name
                deleted_at
                is_readonly
            }
            project_id
            project_id_project{
                name
            }
            table_type
            operation
            object_template_id
            object_template_id_object_template{
                name
            }
        `,
        createVariables: `
            $role_id: String!
            ${rolePermissionVariables}
        `,
        createQuery: `
            role_id: $role_id
            ${rolePermissionQuery}
        `,
        updateVariables: `
            $id: String!,
            $by: String,
            ${rolePermissionVariables}
        `,
        updateQuery: `
            ${rolePermissionQuery}
        `,
    },
    form: [
        {
            name: "operation",
            component: "autocomplete",
            fieldProps: {
                label: "Operation",
                options: {
                    enumName: "PermissionOperation",
                },
                defaultValue: defaultValueEnums,
                docs: {
                    text: "Choose an operation type",
                    urlPath: "/docs/rbac",
                },
            },
        },
        {
            name: "table_type",
            component: "autocomplete",
            fieldProps: {
                label: "Record type",
                options: {
                    enumName: "RecordType",
                },
                defaultValue: defaultValueEnums,
                docs: {
                    text: "Choose a record type",
                    urlPath: "/docs/rbac",
                },
            },
        },
        {
            // only shown when the record type is CUSTOM_OBJECT: optionally
            // restrict the custom-object grant to a single object template
            // (empty = all custom objects). Backed by role_permission.object_template_id.
            name: "object_template_id",
            component: "autocomplete",
            fieldProps: {
                label: "Object template",
                options: {
                    resource: "object_template",
                },
                defaultValue: defaultValueObjectTemplates,
                docs: {
                    text: "Optionally restrict this custom-object permission to a single object template (leave empty for all custom objects)",
                    urlPath: "/docs/rbac",
                },
            },
            fieldAttr: {
                id: "object_template_id",
                placeholder: "All object templates",
                dependee: { fieldName: "table_type", fieldValue: "CUSTOM_OBJECT" },
            },
        },
        {
            // not using the projectfield "common field", since it is not required here
            name: "project_id",
            component: "autocomplete",
            fieldProps: {
                label: "Project",
                options: {
                    resource: "project",
                    resourceBody: "icon",
                },
                defaultValue: defaultValueProjects,
                docs: {
                    text: "Choose a project",
                    urlPath: "/docs/rbac",
                },
            },
            fieldAttr: {
                id: "project_id",
                placeholder: "Select Project",
            },
        },
    ],
    parentData: {
        parentDeletedAt: (data: any) => data?.role_id_role?.deleted_at,
        isParentReadOnly: (data: any) => data?.role_id_role?.is_readonly,
    },
};
export default config;
